import { getSignatureRef } from "tasks/api"
import updateTaskDetailUseCase from "./updateTaskDetailUseCase"

const addSignatureUseCase = async (task, signatureImg) => {
    const { data, detail } = task
    const ref = getSignatureRef(data.id)

    await ref.putString(signatureImg, 'data_url')
    const url = await ref.getDownloadURL()

    if (!detail.signature) {
        detail.signature = {}
    }

    detail.signature = {
        url,
        date: new Date().getTime(),
        data: signatureImg
    }

    return updateTaskDetailUseCase(data.id, detail)
}

export default addSignatureUseCase